import { Component, Input, OnInit } from '@angular/core';
import { TranslateLabelPipe } from '../../core/pipes/translate-label.pipe';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RadioInputComponent } from './components/radio-input.component';
import { FormControl, FormsModule } from '@angular/forms';
import { FormSelect, InputOption } from './types';

export const NAME = 'NullableBinaryFilter';

export const DEFAULT_VALUES = [true, false, 'is_null'];

type NullableBinaryFilterValueType = number | [];

@Component({
  selector: 'app-nullable-binary-filter-input',
  templateUrl: './nullable-binary-filter-input.component.html',
  styleUrls: ['./nullable-binary-filter-input.component.scss'],
  providers: [TranslateLabelPipe],
  imports: [RadioInputComponent, FormsModule],
  standalone: true,
})
export class NullableBinaryFilterInputComponent
  implements FormSelect<NullableBinaryFilterValueType>, OnInit
{
  @Input()
  control: FormControl;

  @Input()
  name: string;

  @Input()
  options: InputOption<NullableBinaryFilterValueType>[];

  @Input()
  value: NullableBinaryFilterValueType;

  constructor(
    public translateService: TranslateService,
    public route: ActivatedRoute,
    public router: Router
  ) {}

  ngOnInit() {
    console.log(
      'nullable-binary-filter-input.component.constructor  ',
      this.name,
      this.control
    );
  }

  static buildFormControl(initialValue: any) {
    const control = new FormControl(initialValue, { nonNullable: true });
    return control;
  }
}
